import { Injectable } from '@angular/core';
import { AuthenticationService } from "./authentication/authentication.service";
import { LoggingService } from "./logging/logging.service";
import { LazyLoadEvent } from "../models/DataTables/lazyLoadEvent";
import { HttpClient } from '@angular/common/http';
import { SubscriptionPlan,UpdateSubsciptionPlan, UpdateUserSubscription } from '../models/inModels/Subscription';

@Injectable()
export class SubscriptionPlanService {
	private routeCategory = '/api/subscriptions/plans';
	constructor(
		private http: HttpClient,
		private auth: AuthenticationService,
		private logging: LoggingService
	) { }

	search(event: LazyLoadEvent): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/search`, JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	get(id: number): Promise<SubscriptionPlan> {
		return this.http.get(`${this.auth.apiUrl}${this.routeCategory}/get/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response as SubscriptionPlan)
			.catch(error => this.logging.handleError(error));
	}

    update(model: UpdateSubsciptionPlan): Promise<SubscriptionPlan> {
        return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/update`, model, { headers: this.auth.header })
            .toPromise()
            .then(response => response as SubscriptionPlan)
            .catch(error => this.logging.handleError(error));
    }

    getDropdown(event): Promise<any> {
	    return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/dropdown`,JSON.stringify(event), { headers: this.auth.header })
		    .toPromise()
		    .then(response => response)
		    .catch(error => this.logging.handleError(error));
    }

    updateUserSubscription(model: UpdateUserSubscription): Promise<any> {
	    return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/update/user`, model, { headers: this.auth.header })
		    .toPromise()
		    .then(response => response)
		    .catch(error => this.logging.handleError(error));
    }

    removeUserSubscription(userId: string): Promise<any> {
	    return this.http.get(`${this.auth.apiUrl}${this.routeCategory}/remove/user/${userId}`, { headers: this.auth.header })
		    .toPromise()
		    .then(response => response)
		    .catch(error => this.logging.handleError(error));
    }

	delete(id: number): Promise<any> {
		return this.http.get(`${this.auth.apiUrl}${this.routeCategory}/delete/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

}



// WEBPACK FOOTER //
// ./src/app/services/subscription.service.ts